module.exports = __webpack_public_path__ + "media/firstscan_club.cb0fa91d.mp4";